import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './TickerReadMode.module.scss'

interface ITickerReadModeProps {
  ticker: string
}

export const TickerReadMode: FC<ITickerReadModeProps> = ({ ticker }) => {
  const formattedTicker = useMemo(() => {
    return !ticker ? '-' : ticker
  }, [ticker])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedTicker}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.tickerLabel} span />
        </div>
      </div>
    </div>
  )
}
